module.exports = __webpack_public_path__ + "static/media/Announcement_Icon_white.6b3417c8.png";